import { Defect } from '@/types/Defecten';

export const getUniekeRijBeperkingDefecten = (defecten: Defect[]): Defect[] => {
  const gezieneRijBeperkingen = new Set<string>();

  return defecten.filter((defect) => {
    if (!defect.rijBeperking || gezieneRijBeperkingen.has(defect.rijBeperking)) return false;

    gezieneRijBeperkingen.add(defect.rijBeperking);
    return true;
  });
};
